module.exports = __webpack_public_path__ + "img/home-s3-img3.c2730e0d.svg";